import { PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'

interface SidebarNewChatButtonProps {
  onClick: () => void
}

export const SidebarNewChatButton = ({ onClick }: SidebarNewChatButtonProps): ReactNode => (
  <SidebarGroup className="py-0">
    <SidebarGroupContent>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            onClick={onClick}
            tooltip="New Chat"
            className="new-chat-button bg-primary text-primary-foreground hover:bg-primary/80 hover:text-primary-foreground"
          >
            <PlusIcon />
            <span>New Chat</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroupContent>
  </SidebarGroup>
)
